import {bridge} from '@eitje/bridge'
import {useLocation, useParams} from 'react-router'
import {store} from '~/store'
import {router} from '~/routing'
import {authService} from './auth'
import {t, mdT, parseT} from './i18n'
import {init, backend} from './eitje_api'
import * as filters from '~/components/filters'
import {useRoleMessage, useSetQueryParams, useQueryParams} from '~/hooks'
import {goBack, navigateModal} from '~/routing/actions'
import {Link, ModalLink} from '~/components'

init()

bridge.setup({
	t,
	mdT,
	parseT,
	backend,
	store,
	auth: authService,
	roles: {useRoleMessage},
	filters,

	// routing
	navigate: router.navigate.bind(router),
	navigateModal,
	goBack,
	useLocation,
	useParams,
	useSetQueryParams,
	useQueryParams,

	// routing components
	Link,
	ModalLink,
})
